export default __webpack_public_path__ + "static/media/remove-liquidity.b50ffd1a.gif";